module.exports = __webpack_public_path__ + "img/msg.f57a159b.svg";